import { render, staticRenderFns } from "./highlights-form.vue?vue&type=template&id=256415c8&scoped=true"
import script from "./highlights-form.vue?vue&type=script&lang=js"
export * from "./highlights-form.vue?vue&type=script&lang=js"
import style0 from "./highlights-form.vue?vue&type=style&index=0&id=256415c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256415c8",
  null
  
)

export default component.exports